import React from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export function Tabs({
  tabs,
  activeTab,
  onTabChange
}: TabsProps) {
  return <div className="border-b border-gray-200" data-id="element-2029">
      <div className="flex space-x-8" data-id="element-2030">
        {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${activeTab === tab.id ? 'border-[#7CB342] text-[#7CB342]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2031">
            {tab.label}
          </button>)}
      </div>
    </div>;
}